<template>
  <div>
    <box-header title="电动汽车换电站">
      <div class="box-header-tab">
        <div @click="changeType('year')" class="tab-item" :class="{'active': type === 'year'}">年视图</div>
        <div @click="changeType('month')" class="tab-item" :class="{'active': type === 'month'}">月视图</div>
        <div @click="changeType('beforeTen')" class="tab-item" :class="{'active': type === 'beforeTen'}">最近十日</div>
      </div>
    </box-header>

    <div class="box" style="height: 420px;background: rgba(7,17,32,.3);">
      <box-border line></box-border>
      <div class="box-filter">
        <div class="box-count">
          <span class="count-name">充电总量：</span>
          <span class="count-value">{{ sumChargingAmount }}</span>
          <span class="count-unit">kwh</span>
        </div>

        <div class="box-count">
          <span class="count-name">换电总量：</span>
          <span class="count-value">{{ sumConverterAmount }}</span>
          <span class="count-unit">kwh</span>
        </div>

        <div v-if="type === 'year'" class="box-select">
          <el-select :value="currentYear" @change="changeYear" placeholder="请选择">
            <el-option
                v-for="(year,index) in yearList"
                :key="index"
                :value="year"
                :label="year + '年'"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="type === 'month'" class="box-select">
          <el-select :value="currentMonth" @change="changeMonth" placeholder="请选择">
            <el-option
                v-for="(month,index) in monthList"
                :key="index"
                :value="month"
                :label="month + '月'"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div style="height: calc(100% - 80px);background: rgba(10, 27, 46, .51);">
        <div id="ConverterStationChartBox" class="chart"></div>
      </div>
    </div>

    <ConverterStationStatisticsDetail ref="ConverterStationDetail" />
  </div>
</template>
<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader.vue";
import BoxBorder from "@/components/BoxBorder/BoxBorder.vue";

import ConverterStationStatisticsDetail from "@/components/ConverterStation/ConverterStationStatisticsDetail.vue";
const yearMonthList = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
export default {
  name: "ConverterStationStatistics",
  components: { BoxBorder, BoxHeader ,ConverterStationStatisticsDetail },
  data() {
    return {
      name: "换电站销量统计",
      type: "beforeTen",
      yearList: ["2023","2024","2025","2026"],
      currentYear: "",
      monthList: ["12","11","10","9","8","7","6","5", "4", "3", "2", "1"],
      currentMonth: "",
      chargingAmount:[],
      converterAmount:[],
      sectionData: [],
      category: [],
      dateCateGory: [],
      max: 0,
      count: 0,
      sumChargingAmount:0,
      sumConverterAmount:0
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.currentYear =  new Date().getFullYear() +"";
      this.chart = this.$echarts.init(document.getElementById("ConverterStationChartBox"));
      this.bindEvents();
      this.getData();
    });
  },
  methods: {
    //点击实体柱子 fuck
    bindEvents() {
        this.chart.on("click", (data) => {
          if (this.type === "year") {
            return false;
          }
          if(this.type === "month") {
            let day = this.category[data.dataIndex];
            if (day) {
              day = parseInt(day);
            }
            const date = this.currentYear + '-' + this.$util.padStartInt(this.currentMonth,2) + '-' + this.$util.padStartInt(day,2);
            this.$refs.ConverterStationDetail.open({date});
          }else{
            let date = this.dateCateGory[data.dataIndex];
            this.$refs.ConverterStationDetail.open({date});
          }
        });
    },
    getData() {
      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254, 1)",
      });

      if (this.type === "year") {
        this.$api.getConverterStatisticsByYear(this.currentYear)
            .then(res => {
              this.disposeData(res.data);
            });
      }

      if (this.type === "month") {
        this.$api.getConverterPowerByMonth(this.currentYear,this.currentMonth)
            .then(res => {
              this.disposeData(res.data);
            });
      }

      //最近十日大屏数据
      if(this.type === 'beforeTen'){
         const today = new Date();
         const formattedToday = today.toISOString().split('T')[0];
         const tenDaysAgo = new Date();
         tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
         const formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0];

         this.$api.getConverterPowerByDateRange({begin: formattedTenDaysAgo,end: formattedToday}).then(res=>{
           this.disposeData(res.data);
         })
      }
    },
    disposeData(sourceData) {
      if(this.type ==='beforeTen'){
        sourceData.sort((a, b) => new Date(a.order_date) - new Date(b.order_date));
        let dateList = sourceData.map(item=>item.order_date);
        let result = sourceData.map(item => {
          let day = item.order_date.split('-')[2]; // 例如 "13"
          if(day.startsWith("0")){
            day = day.replace("0","");
          }
          return `${day}日`; // 转换为 "13日"
        });
         this.dateCateGory = dateList;
         this.category = result;
      }else{
        if (this.type === "year") {
          this.category = yearMonthList;
        } else {
          this.category = sourceData.map(item => item.rq + "日");
        }
      }
      this.chargingAmount = sourceData.map(item => item.charging_amount);
      this.converterAmount = sourceData.map(item => item.converter_amount);
      this.sumChargingAmount = this.$lodash.sum(this.chargingAmount).toFixed(2);
      this.sumConverterAmount = this.$lodash.sum(this.converterAmount).toFixed(2);
      this.renderChart();
    },
    renderChart() {
      this.chart.hideLoading();
      const barWidth = 30;
      const colorArr = ["#58C9B9", "#58C9B9", "#4F86C6","#4FB0C6"];

      const color1 = {
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: colorArr[0]
          },
          {
            offset: 0.5,
            color: colorArr[0]
          },
          {
            offset: 0.5,
            color: colorArr[0]
          },
          {
            offset: 1,
            color: colorArr[0]
          }
        ]
      };
      const color2 = {
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: colorArr[2]
          },
          {
            offset: 0.5,
            color: colorArr[2]
          },
          {
            offset: 0.5,
            color: colorArr[2]
          },
          {
            offset: 1,
            color: colorArr[2]
          }
        ]
      };
      let options = {
        legend: {
          show: true,
          top: 0,
          itemWidth: 40,
          itemGap: 80,
          lineStyle: {
            width: 10
          },
          textStyle: {
            fontFamily: "Alibaba PuHuiTi",
            padding: 10,
            height: 26,
            fontSize: 24,
            color: "rgba(211, 238, 254, 1)"
          }
        },
        tooltip: {
          show: true,
          trigger: "axis",
          confine: true,
          className: "echarts-tooltip",
          extraCssText: "padding: 20px 30px",
          formatter: function (dataList) {
            let html = `<div class="name" style="font-size: 30px;font-weight: 500">${dataList[0].axisValueLabel}`;
            dataList.forEach(data => {
              html += `<div class='title' style='margin-top: 20px;'>${data.seriesName}</div><div class='value'>${data.value}<span class='unit'>度</span></div>`;
            });
            html += "</div>";
            return html;
          },
          textStyle: {
            fontSize: 30
          }
        },
        grid: {
          top: 50,
          bottom: 30,
          left: 30,
          right: 50,
          containLabel: true
        },
        dataZoom: [{
          type: "inside",
          show: true,
          startValue: 0,
          endValue: 11,
          rangeMode: ["value"],
          zoomLock: true
        }],
        xAxis: {
          type: "category",
          data: this.category,
          splitNumber: 6.5,
          axisLabel: {
            show: true,
            margin: 25,
            interval: 0,
            fontSize: 22,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          boundaryGap: true
        },
        yAxis: {
          type: "value",
          name: "kwh",
          nameLocation: "end",
          nameGap: 25,
          nameTextStyle: {
            fontSize: 22,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .6)"
          },
          axisLabel: {
            margin: 25,
            fontSize: 24,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .8)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          }
        },
        series: [
          {
            name: "充电量",
            type: "bar",
            data: this.chargingAmount,
            barWidth: barWidth,
            itemStyle: {
              normal: {
                color: color1
              }
            },
          },
          {
            name: "换电量",
            type: "bar",
            data: this.converterAmount,
            barWidth: barWidth,
            itemStyle: {
              normal: {
                color: color2
              }
            },
          }
        ]
      };
      this.chart.setOption(options);
    },
    changeType(type) {
      this.type = type;
      let time = new Date();
      this.currentMonth = (time.getMonth() + 1) + "";
      this.getData();
    },
    changeYear(year) {
      this.currentYear = year;
      this.getData();
    },
    changeMonth(month) {
      this.currentMonth = month;
      this.getData();
    },
  },
};
</script>
<style scoped lang="scss">
.box-header-tab {
  display: flex;
  flex-direction: row;
  align-items: center;

  .tab-item {
    width: 166px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: url("../../assets/image/bg_tab_un.png");
    color: rgba(161, 197, 234, .7);
    font-size: 30px;
    line-height: 72px;
    font-family: "screen", serif;
    margin-right: 25px;
    cursor: pointer;

    &.active {
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, .56), 0 0 1em rgba(82, 163, 255, .56);
      background: url("../../assets/image/bg_tab_on.png");
    }
  }
}

.box-filter {
  display: flex;
  justify-content: space-between;
  padding: 15px 30px;
  padding-bottom: 0;
  box-sizing: border-box;
  height: 90px;
}

.box-count {
  height: 60px;
  line-height: 60px;

  .count-name {
    font-size: 25px;
    color: rgb(181, 228, 255);
  }

  .count-value {
    font-size: 30px;
    color: rgb(86, 237, 255);
    font-family: "screen", serif;
  }

  .count-unit {
    font-size: 15px;
    color: rgba(181, 228, 255, 0.6);
    margin-left: 10px;
  }
}

.box-select {
  width: 200px;

  ::v-deep.el-input {
    font-size: 30px;

    .el-input__inner {
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>
